import { Typography } from '@mui/material'
import { FormText } from './FormText'
import { parseLabel } from '../../parseLabel'

export function FormTextPrint (props) {
  const parsedTitle = parseLabel(props.title)

  return (
    <Typography className='form-read-only-text'>
      <FormText {...props} title={parsedTitle} />
    </Typography>
  )
}
